// @flow
import React from 'react';
import {PropTypes} from 'prop-types';
import {Hidden} from '@material-ui/core';

import {Divider, makeStyles, Typography} from '@material-ui/core';
import CustomButton from '../../../elements/CustomButton/CustomButton';
import {colors} from '../../../assets/styles/colors';
import videoCamera from '../../../assets/img/videoCamera.svg';
import wsspIcon from '../../../assets/img/wssp-bg-green.svg';
import specialist from '../../../assets/img/specialist.png';

import {TIENDADA_LINKS} from '../../../constants';

type Props = {|
  size?: string,
|};

export const useStyles = (size: string) =>
  makeStyles(theme => ({
    root: {
      display: 'flex',
      [theme.breakpoints.up('lg')]: {
        marginTop: size === 'large' && theme.spacing(3),
      },
      [theme.breakpoints.down('md')]: {
        marginTop: size === 'large' && theme.spacing(4),
      },
      borderRadius: '12px',
      boxShadow:
        '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
      background: 'white',
      padding: theme.spacing(2),
    },
    leftSection: {
      [theme.breakpoints.up('lg')]: {
        minWidth: 300,
      },
    },
    title: {
      display: 'flex',
      '& img': {
        width: '2rem',
      },
      // alignItems: 'center',
    },
    subtitle: {
      color: '#717190',
      fontSize: '14px',
    },
    description: {
      margin: theme.spacing(2, 0),
      color: '#3A3A49',
      fontSize: '14px',
      fontWeight: 600,
      textAlign: 'justify',
    },
    titleFont: {
      // marginLeft: theme.spacing(2),
      fontWeight: 600,
      fontSize: '1.125rem',
    },
    seeMoreEventsButton: {
      marginTop: theme.spacing(2),
      width: '100%',
      [theme.breakpoints.up(size === 'large' ? 'lg' : 'xl')]: {
        maxWidth: 300,
      },
      backgroundColor: colors.lightPurple,
      borderRadius: '6px',
      fontWeight: 600,
    },
    events: {
      [theme.breakpoints.up(size === 'large' ? 'lg' : 'xl')]: {
        margin: theme.spacing(0, 4),
      },
    },
    event: {
      padding: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
    },
    eventCategory: {fontSize: '0.875rem', color: colors.grey700},
    eventTitle: {
      marginTop: theme.spacing(1),
      marginBottom: 'auto',
      fontSize: '0.875rem',
      fontWeight: 600,
    },
    eventRegisterButton: {
      [theme.breakpoints.up(size === 'large' ? 'md' : 'sm')]: {
        marginTop: theme.spacing(1),
      },
      [theme.breakpoints.down(size === 'large' ? 'sm' : 'xs')]: {
        marginLeft: 'auto',
      },
      border: `1px solid ${colors.purple3}`,
      fontSize: '0.75rem',
      width: 120,
      padding: '2px 16px',
      fontWeight: 600,
    },
    divider: {
      backgroundColor: colors.grey200,
      margin: '0 0 -1px -1px',
      // height: '100%',
      width: 1,
      [theme.breakpoints.down(size === 'medium' ? 'xs' : 'sm')]: {
        width: '100%',
        height: 1,
      },
    },
    dividerSpecialist: {
      backgroundColor: colors.grey200,
      margin: '1rem 0',
      width: '100%',
    },
    verticalDivider: {
      backgroundColor: colors.grey200,
      margin: '0 3rem',
      width: '1px',
      height: '150px',
    },
    specialist: {
      color: '#717190',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.up('md')]: {
        marginTop: '-3.25rem',
      },
      [theme.breakpoints.up('lg')]: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '15rem',
      },
    },
    specialistName: {
      textAlign: 'center',
      fontSize: '14px',
      fontWeight: 600,
      [theme.breakpoints.up('md')]: {
        marginTop: theme.spacing(1),
      },
    },
    specialistDesc: {
      textAlign: 'center',
      fontSize: '14px',
      fontWeight: 400,
    },
    btnWssp: {
      color: '#25D366',
      display: 'flex',
      justifyContent: 'space-between',
      border: '1px solid #25D366',
      '&:focus, &:hover': {
        border: '1px solid #25D366',
      },
      '& img': {
        marginLeft: '2rem',
        width: '1.5rem',
      },
      [theme.breakpoints.down('md')]: {
        maxWidth: '90%',
      },
    },
    textBtnWssp: {
      color: '#25D366',
      fontSize: '14px',
      fontWeight: 600,
    },
    wrapperBtnWssp: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [theme.breakpoints.up('md')]: {
        alignItems: 'start',
        padding: '0',
      },
    },
    contentSpecialist: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    },
    wrapperInfo: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        marginLeft: theme.spacing(2),
      },
    },
  }));

// const events = [
//   {
//     category: 'Conoce TiendaDa',
//     title: '¿Cómo usar TiendaDa?',
//     link:
//       'https://zoom.us/meeting/register/tJEkcuGqrDwuHtBAqfdAwYbacVF3J-WWc_Hi',
//   },
//   {
//     category: 'Taller de',
//     title: '¿Cómo comenzar a vender en internet?',
//     link:
//       'https://zoom.us/meeting/register/tJMrc-mqrDwrHdYs1LOrT0Mw3_V2VyGd_Nyx',
//   },
//   {
//     category: 'Conoce TiendaDa PRO',
//     title: 'Te enseñamos las funcionalidades PRO',
//     link:
//       'https://zoom.us/meeting/register/tJIrdOisrDouGd2j65TyhmB7_JM_Ob6272Uz',
//   },
// ];

export default function EventsSection(props: Props) {
  const {size = 'large'} = props;
  const classes = useStyles(size)();

  // const eventsComponent = (
  //   <Grid container className={classes.events}>
  //     {events.map((e, i: number) => (
  //       <React.Fragment key={e.title}>
  //         {i > 0 && <div className={classes.divider} />}
  //         <Grid
  //           item
  //           className={classes.event}
  //           xs={12}
  //           sm={size === 'medium' ? 4 : 12}
  //           md={4}
  //         >
  //           <div style={{display: 'flex', alignItems: 'center'}}>
  //             <Typography className={classes.eventCategory}>
  //               {e.category}
  //             </Typography>
  //             <Hidden mdUp={size === 'large'} smUp={size === 'medium'}>
  //               <CustomButton
  //                 className={classes.eventRegisterButton}
  //                 color="primary"
  //                 href={e.link}
  //                 target="_blank"
  //                 rel="noopener noreferrer"
  //               >
  //                 Regístrate aquí
  //               </CustomButton>
  //             </Hidden>
  //           </div>
  //           <Typography className={classes.eventTitle}>{e.title}</Typography>
  //           <Hidden smDown={size === 'large'} xsDown={size === 'medium'}>
  //             <CustomButton
  //               className={classes.eventRegisterButton}
  //               color="primary"
  //               href={e.link}
  //               target="_blank"
  //               rel="noopener noreferrer"
  //             >
  //               Regístrate aquí
  //             </CustomButton>
  //           </Hidden>
  //         </Grid>
  //       </React.Fragment>
  //     ))}
  //   </Grid>
  // );

  const specialistSection = (
    <div className={classes.specialist}>
      <img src={specialist} alt="specialist" />
      <div className={classes.wrapperInfo}>
        <Typography className={classes.specialistName}>Vania</Typography>
        <Typography className={classes.specialistDesc}>
          Especialista en
          <br /> venta digital
        </Typography>
      </div>
    </div>
  );

  return (
    <div className={classes.root}>
      <div className={classes.leftSection}>
        <div className={classes.title}>
          <img src={videoCamera} alt="videoCamera" />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: '1rem',
            }}
          >
            <Typography className={classes.titleFont}>
              Atención en Vivo
            </Typography>
            <Typography className={classes.subtitle}>
              Lunes a viernes de 9am-6pm (GMT-5)
            </Typography>
          </div>
        </div>
        <div className={classes.contentSpecialist}>
          <div>
            <Typography className={classes.description}>
              ¿Tienes dudas? ¿Quieres conocer a detalle alguna funcionalidad? ¿O
              tan sólo quieres recomendaciones? Estamos aquí para apoyarte.
            </Typography>
            <div className={classes.wrapperBtnWssp}>
              <CustomButton
                variant="outlined"
                className={classes.btnWssp}
                href={TIENDADA_LINKS.customerSupport.general}
                target="_blank"
                rel="noopener noreferrer"
                id="contact-us"
              >
                <div>
                  <Typography className={classes.textBtnWssp}>
                    Escríbenos por WhatsApp
                  </Typography>
                </div>
                <img src={wsspIcon} alt="contact icon" />
              </CustomButton>
              <Typography
                className={classes.subtitle}
                style={{margin: '1rem 0'}}
              >
                Clic en el botón o guarda este número +1 (845) 403-0926
              </Typography>
            </div>
          </div>
          <Hidden smDown>
            <Divider
              orientation="vertical"
              className={classes.verticalDivider}
            />
          </Hidden>
          <Hidden mdUp>
            <Divider className={classes.dividerSpecialist} />
          </Hidden>
          {specialistSection}
          {/* <CustomButton
            color="primary"
            className={classes.seeMoreEventsButton}
            href="https://tiendada.super.site/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ver más eventos aquí
          </CustomButton> */}
        </div>
      </div>
    </div>
  );
}

EventsSection.propTypes = {
  size: PropTypes.string,
};
